import { all, takeLatest } from "redux-saga/effects";
import HttpService from "../../../services/HttpService";
/**
 *
 * @param {{ idTerm: number, token: string }} payload
 */
export function* acceptTerms({ payload }) {
	const { idTerm, token } = payload;
	try {
		const param = {
			idTerm,
			token,
			ip: yield HttpService.getRegionIp(),
		};

		const resp = yield HttpService.approveTerms(param);

		if (!resp.success) throw resp;
	} catch (error) {
		console.error("[ERROR HANDLE_ADJUST_EVENT]", error);
	}
}

export default all([takeLatest("@terms/ACCEPT_TERMS", acceptTerms)]);
